"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Aug 23 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var CompetitorProduct_1 = require("../model/CompetitorProduct");

var CompetitorProductConverter_1 = require("./CompetitorProductConverter");

var ProductEANConverter_1 = require("./ProductEANConverter");
/**
 * Implementation of {@link CompetitorProductConverter}.
 *
 * @author RV
 */


var CompetitorProductConverterImpl =
/*#__PURE__*/
function (_CompetitorProductCon) {
  _inherits(CompetitorProductConverterImpl, _CompetitorProductCon);

  function CompetitorProductConverterImpl(productEANConverter) {
    var _this;

    _classCallCheck(this, CompetitorProductConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorProductConverterImpl).call(this));
    _this.productEANConverter = productEANConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(CompetitorProductConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new CompetitorProduct_1.CompetitorProduct(conversions.documentToClassId(source), CompetitorProduct_1.CompetitorProduct.schema.eans.valueOf(conversions.asObjectList(source, 'eans', function (document) {
        return _this2.productEANConverter.toObject(document, conversions);
      })), source.name, source.productSize, source.productSizeUnit, source.category, source.productContent, source.productSpecification, conversions.asObjectList(source, 'suppliers', function (name) {
        return name;
      }), source.ignored, CompetitorProduct_1.CompetitorProduct.schema.competitorId.valueOf(conversions.toClassReferenceId(source.competitorId)), source.competitorExternalId, source.externalId, source.specialId, source.available, source.comment, conversions.asObjectList(source, 'compoundId', function (id) {
        return id;
      }), source.internalCategoryIds && conversions.asClassReferenceIdsList(source, 'internalCategoryIds'));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        eans: conversions.asObjectArray(source, 'eans', function (productEAN) {
          return _this3.productEANConverter.toDocument(productEAN, conversions);
        }),
        name: source.name,
        productSize: source.productSize,
        productSizeUnit: source.productSizeUnit,
        category: source.category,
        productContent: source.productContent,
        productSpecification: source.productSpecification,
        suppliers: conversions.asObjectArray(source, 'suppliers', function (name) {
          return name;
        }),
        ignored: source.ignored,
        competitorId: conversions.toDocumentReferenceId(source.competitorId),
        competitorExternalId: source.competitorExternalId,
        externalId: source.externalId,
        specialId: source.specialId,
        available: source.available,
        comment: source.comment,
        compoundId: conversions.asObjectArray(source, 'compoundId', function (id) {
          return id;
        }),
        internalCategoryIds: source.internalCategoryIds && conversions.asObjectArray(source, 'internalCategoryIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        })
      });
      return result;
    }
  }]);

  return CompetitorProductConverterImpl;
}(CompetitorProductConverter_1.CompetitorProductConverter);

CompetitorProductConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ProductEANConverter_1.ProductEANConverter])], CompetitorProductConverterImpl);
exports.CompetitorProductConverterImpl = CompetitorProductConverterImpl;